export default "__VITE_ASSET__B21QYvTT__"